import gql from 'graphql-tag'
import api from '../inventario/apiClient'

export default {
  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            GastosActivos {
              readAllByEmisor(emisor: $emisor) {
                _id
                nombre
                descripcion
                tipo
                unidadMedida {
                  id
                }
                codigoMoneda {
                  id
                }
                costoUnitarioTotal
                cuentaContable
                codigo
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.GastosActivos.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: GastosActivosInput!) {
            GastosActivos {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.GastosActivos.create),

  delete: (_idEmisor, input) =>
    api
      .send({
        query: gql`
          mutation delete($_idEmisor: ID!, $input: [ID!]!) {
            GastosActivos {
              delete(_idEmisor: $_idEmisor, input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { _idEmisor, input }
      })
      .then(result => result.data.data.GastosActivos.delete)
}
